<template>
  <div id="purchase" class="page">
    <el-row class="hp-row content-default" type="flex">
      <el-col v-if="centerPanel !== null" class="center column animated fadeInRight">
        <div class="col-content">
          <user-address v-if="centerPanel === centerPanelOptions.address"
            :userInfoProp="userInfo"
            :accessorComponentProp="'purchasePlan'"
            @user-address-change="handleUserAddressSubCompChange($event)">
          </user-address>
          <user-purchase-summary v-else-if="centerPanel === centerPanelOptions.summary"
            :accessorComponentProp="'purchasePlan'"
            @purchase-summary-change="handleInvoiceSummarySubCompChange($event)">
          </user-purchase-summary>
          <div v-else-if="centerPanel === centerPanelOptions.finish" class="finish-content">
              <div :class="['gradient-card', 'default', { 'plain-card': $utils.isPageForLicenses() }]">
              <div class="header">
                <h4 class="title"></h4>
              </div>
              <div class="body">
                <div class="icon"></div>

                <div class="text-wrapper">
                  <div class="text account-switched">{{$t('label.purchasePlanUpgradeSuccessMain', { plan: $utils.options.plans.PREMIUM })}}</div>
                </div>

                <el-button class="cstm-btn-white" @click="handleContinueClick">{{$t('label.continue')}}</el-button>
              </div>
              </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script src="./purchase-plan.js"></script>
<style lang="scss" src="./purchase-plan.scss"></style>
